import Vue from './vue-config'

if (document.getElementById('routes')) {
    new Vue({
        el: '#routes',
        data: {
            pageId: 0,
            durations: [],
            durationId: 0,
            difficulties: [],
            difficultyId: 0,
            routes: [],
        },
        methods: {
            setDuration(id) {
                this.durationId = id
                this.doSearch()
            },
            setDifficulty(id) {
                this.difficultyId = id
                this.doSearch()
            },
            doSearch() {
                var vm = this
                vm.doPost('/umbraco/surface/route/getroutes', {
                    pageId: vm.pageId,
                    durationId: vm.durationId,
                    difficultyId: vm.difficultyId
                }, (data) => {
                    vm.routes = data
                })
            }
        },
        watch: {
            durationId() {
                this.doSearch()
            },
            difficultyId() {
                this.doSearch()
            }
        },
        updated() {
            window.lazyLoad.update()
        },
        mounted() {
            var vm = this
            vm.pageId = vm.$el.dataset.id
            vm.doPost('/umbraco/surface/route/getfilters', { pageid: vm.pageId }, (data) => {
                vm.durations = data.durations
                vm.difficulties = data.difficulties
                vm.doSearch()
            })
        }
    })
}